import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO, generateWebPageSchema } from '../../utils/seo';
import CasesNavbar from './components/CasesNavbar';
import CasesHero from './components/CasesHero';
import CaseCard from './components/CaseCard';
import GlobalMetrics from './components/GlobalMetrics';
import CasesCTA from './components/CasesCTA';
import CasesFooter from './components/CasesFooter';
import { caseStudies } from '../../mocks/caseStudies';

export default function CasesPage() {
  const [scrolled, setScrolled] = useState(false);
  const [activeFilter, setActiveFilter] = useState('Todos');
  const [filteredCases, setFilteredCases] = useState(caseStudies);

  const filters = ['Todos', 'Barbearia', 'Clínica', 'Imobiliária', 'Fitness', 'Automotivo', 'Consultoria'];

  // SEO Configuration
  useSEO({
    title: 'Casos de Sucesso - Resultados Reais com IA da NeuroAgents',
    description: 'Veja casos reais de empresas que transformaram seu atendimento com IA. Barbearias, clínicas, imobiliárias e mais aumentaram vendas em até 340% e reduziram custos em 60% com automação inteligente.',
    keywords: 'casos de sucesso IA, resultados automação atendimento, ROI inteligência artificial, cases empresas brasileiras, transformação digital atendimento',
    canonical: '/casos-de-sucesso',
    type: 'website',
    jsonLd: generateWebPageSchema({
      name: 'Casos de Sucesso NeuroAgents',
      description: 'Resultados reais de empresas que implementaram automação com IA',
      url: '/casos-de-sucesso',
    }),
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (activeFilter === 'Todos') {
      setFilteredCases(caseStudies);
    } else {
      setFilteredCases(caseStudies.filter(c => c.category === activeFilter));
    }
  }, [activeFilter]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white font-sans">
      <CasesNavbar scrolled={scrolled} />
      <CasesHero />
      
      {/* Filtros */}
      <section className="py-8 bg-[#0A0A0A] sticky top-16 z-40 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap items-center gap-3">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeFilter === filter
                    ? 'bg-[#10B981] text-black'
                    : 'bg-white/5 text-white/70 hover:bg-white/10 hover:text-white'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Grid de Casos */}
      <section className="py-20 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredCases.map((caseStudy, index) => (
              <CaseCard key={caseStudy.id} caseStudy={caseStudy} index={index} />
            ))}
          </div>
        </div>
      </section>

      <GlobalMetrics />
      <CasesCTA />
      <CasesFooter />
    </div>
  );
}
